// extracted by mini-css-extract-plugin
export default {"block":"Auth_block__BeDUl","authForm":"Auth_authForm__RCK+t"};